import { useInfiniteQuery } from 'react-query';

import { Group } from 'views/App/Portal/LexID/Groups/_types/group';
import { ApiCollectionResponse } from 'types/api_response';
import {
  baseApiUrl,
  fetcher,
  infiniteEmptyResults,
  ServerErrorResponse,
  createParamString,
} from 'data_sources/constants';

export default function useGroups<T extends Group>(
  organizationId?: string,
  params = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/user-group/v1/organizations/${organizationId}/groups`;

  return useInfiniteQuery<ApiCollectionResponse<T>, ServerErrorResponse>(
    ['groups', organizationId, params],
    async ({ pageParam, signal }): Promise<ApiCollectionResponse<T>> => {
      try {
        const paramString = createParamString(params);
        const data: ApiCollectionResponse<T> = await fetcher({
          url: pageParam || `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      enabled: !!organizationId,
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (lastPage.offset && lastPage.offset < (lastPage.count || 0) && lastPage.content.length > 0) {
          const paramString = createParamString({
            ...params,
            offset: lastPage.offset,
          });
          return `${url}?${paramString}`;
        }
      },
      ...options,
    }
  );
}
